import React from "react"
import { Container, Stack, Flex, Heading, Text, Box } from "@chakra-ui/react"
import CustomBadge from "./badge"
import CtaButton from "./ctaButton"

interface SectionItem {
  badge: string
  title: string
  text: string
  component: JSX.Element
  textOnLeft: boolean
  cta: string
}

function GenericSection({
  badge,
  title,
  text,
  component,
  textOnLeft,
  cta,
}: SectionItem): JSX.Element {
  return (
    <Container maxW={"7xl"} px={{ base: 4, md: 12 }}>
      <Stack
        align={"center"}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 12, md: 20 }}
        direction={{ base: "column", md: "row" }}
      >
        <Stack
          flex={1}
          spacing={{ base: 5, md: 10 }}
          order={{ base: 1, md: textOnLeft ? 1 : 2 }}
        >
          <Stack>
            <CustomBadge text={badge} />
            <Heading
              lineHeight={1.1}
              fontWeight={600}
              fontSize={{ base: "2xl", sm: "3xl", lg: "5xl" }}
            >
              <Text as={"span"}>{title}</Text>
            </Heading>
          </Stack>
          <Text
            color={"gray.700"}
            fontSize={{ base: "md", sm: "md", lg: "xl" }}
          >
            {text}
          </Text>
          <CtaButton text={cta} />
        </Stack>
        <Flex
          flex={1}
          justify={"center"}
          align={"center"}
          position={"relative"}
          w={"full"}
          order={{ base: 2, md: textOnLeft ? 2 : 1 }}
          dir={textOnLeft ? "ltr" : "rtl"}
        >
          <Box
            position={"relative"}
            rounded={"md"}
            boxShadow={"md"}
            width={"full"}
            p={4}
          >
            {component}
          </Box>
        </Flex>
      </Stack>
    </Container>
  )
}

export default GenericSection
